export default __webpack_public_path__ + "static/media/1019.c5f7f798.svg";